export default [
  {
    name: 'Australia',
    displayName: {
      en: 'Australia',
      vi: 'Úc',
    },
  },
];
